import { render, staticRenderFns } from "./goal-lookup.vue?vue&type=template&id=f3342080"
import script from "./goal-lookup.vue?vue&type=script&lang=ts"
export * from "./goal-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports